/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} File_Upload_Error_HeifInputs */

const vi_file_upload_error_heif = /** @type {(inputs: File_Upload_Error_HeifInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ảnh iPhone định dạng HEIC chưa hỗ trợ. Mở Cài đặt → Camera → Định dạng, chọn "Tương thích nhất" rồi chụp lại, hoặc chọn ảnh JPG.`)
};

/**

* @param {File_Upload_Error_HeifInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const file_upload_error_heif = /** @type {((inputs?: File_Upload_Error_HeifInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<File_Upload_Error_HeifInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_file_upload_error_heif(inputs)
});